module.exports = __webpack_public_path__ + "static/media/leftsmall.87714bca.svg";